//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action

import * as guideAction from '../action/guideAction';

//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';

//Icon
import CloseIcon from '@material-ui/icons/Close';


import imgAppIos from '../img/app/app_link_button_ios.png';
import imgAppAndroid from '../img/app/app_link_button_android.png';

import imgQrIos from '../img/app/app_qr_ios.png';
import imgQrAndroid from '../img/app/app_qr_android.png';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class Comp extends React.Component {
	render() {
		return (
      <Dialog
        fullScreen
        open={this.props.guide.app.visible}
        onClose={ () => this.props.guideAppSet(false) }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%',zIndex:'100'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              アプリをインストールする
            </div>
            <div>
              <IconButton onClick={ () => this.props.guideAppSet(false) }>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
        <DialogContent>
          <div style={{margin:'15px'}}>
            <h2 align='center'>パートナーズはアプリからも<br/>ご利用いただけます</h2>
            <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
              <li>機能はそのまま、ブラウザ版と同じ機能ご利用いただけます。</li>
              <li>リアルタイムにプッシュ通知が届きます。</li>
              <li>再登録の必要はありません。ブラウザとアプリで共通のアカウントを利用できます。</li>
            </ul>
          </div>
          <div style={{padding:'10px'}} align='center'>
            <Grid container  justifyContent="center" alignItems="center" spacing={3} style={{margin:'5px'}}>
              <Grid item>
                <a href='https://apps.apple.com/jp/app/partners/id1626274488' target='_blank' rel="noreferrer">
                  <img
                    src={ imgAppIos }
                    style={{height:'60px',width:'auto'}}
                    alt=''
                  />
                </a>
              </Grid>
              <Grid item>
                <a href='https://apps.apple.com/us/app/partners/id1626274488' target='_blank' rel="noreferrer">
                  <img
                    src={ imgQrIos }
                    alt=''
                  />
                </a>
              </Grid>
            </Grid>
            <Grid container  justifyContent="center" alignItems="center" spacing={3} style={{margin:'5px'}}>
              <Grid item>
                <a href='https://play.google.com/store/apps/details?id=net.partners.app' target='_blank' rel="noreferrer">
                  <img
                    src={ imgAppAndroid }
                    style={{height:'60px',width:'auto'}}
                    alt=''
                  />
                </a>
              </Grid>
              <Grid item>
                <a href='https://play.google.com/store/apps/details?id=net.partners.app' target='_blank' rel="noreferrer">
                  <img
                    src={ imgQrAndroid }
                    alt=''
                  />
                </a>
              </Grid>
            </Grid>
          </div>
          <div style={{margin:'15px'}}>
            <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
              <li>アプリをダウンロードしてください。</li>
              <li>アプリが起動したらログインを押してください。</li>

              <li>
                下記の情報でログインしてください。<br/>
                ログインID: {this.props.my.setting.loginId}<br/>
                ログインパスワード: {this.props.my.setting.loginPass}
              </li>
              <li>アプリでご利用後でもブラウザ版からもご利用いただけます。</li>
            </ul>
          </div>
          <div style={{margin:'15px'}}>
            <div style={{fontSize:'0.9em',color:'#666'}}>
              ※アプリ内の決済とブラウザ版からの有料サービスはご料金が異なります。
              ブラウザ版で有料サービスにお申し込みいただいてアプリでご利用いただくことも可能です。
            </div>
          </div>
        </DialogContent>
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
		guide: state.guide,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
